import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";

// Routes backoffice du jeu de pronostic (Coupe du Monde 2026).
// Branche dans getBackOfficeGroupAdmin / getBackOfficeGroupSuperAdmin.
export const routeBackOfficeGameAdminCommon = [
  {
    // Plus dans le menu de gauche : accès via le dashboard (onglet Pronostic → « Gérer les tournois »).
    route: "GameList",
    text: "Coupe du Monde 2026",
    icon: SportsSoccerIcon,
    href: "/backoffice/group/game",
    menuHeader: false,
    position: 320
  },
  {
    route: "addGame",
    text: "Ajouter un tournoi",
    href: "/backoffice/group/game/add-game",
    menuHeader: false
  },
  {
    route: "editGame",
    text: "Editer un tournoi",
    href: "/backoffice/group/game/edit-game/[gameId]",
    menuHeader: false
  },
  {
    route: "gameResults",
    text: "Saisie des résultats",
    href: "/backoffice/group/game/[gameId]/results",
    menuHeader: false
  }
];
